export default "__VITE_ASSET__BNf0rZOk__"